import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { linkProps } from "../lib/navLink.jsx";

/**
 * Full-width dark hero — mirrors AWS's deep-gradient announcement banner.
 * hero props: kicker, headline, subheadline,
 *   primaryCtaLabel, primaryCtaHref,
 *   secondaryCtaLabel, secondaryCtaHref
 */
export default function Hero({ hero }) {
  if (!hero) return null;

  const hasImage = Boolean(hero.imageUrl);
  const sectionStyle = hasImage
    ? { backgroundImage: `url(${hero.imageUrl})` }
    : undefined;

  return (
    <section
      className={`pmp-hero${hasImage ? " pmp-hero--image" : ""}`}
      id="top"
      style={sectionStyle}
    >
      <Container className="position-relative" style={{ zIndex: 1 }}>
        <Row>
          <Col lg={8} xl={7}>
            <p className="pmp-kicker mb-3">
              {hero.kicker ?? "Medical supplies · Equipment · PPE · Diagnostics"}
            </p>
            <h1 className="display-5 mb-3">{hero.headline}</h1>
            <p className="lead mb-5">{hero.subheadline}</p>
            <div className="d-flex gap-3 flex-wrap align-items-center">
              {hero.primaryCtaLabel && (
                <Button
                  variant="success"
                  {...linkProps(hero.primaryCtaHref, { fallback: "#capabilities" })}
                  size="lg"
                  className="px-4"
                >
                  {hero.primaryCtaLabel}
                </Button>
              )}
              {hero.secondaryCtaLabel && (
                <Button
                  variant="outline-light"
                  {...linkProps(hero.secondaryCtaHref, { fallback: "#contact" })}
                  size="lg"
                  className="px-4"
                >
                  {hero.secondaryCtaLabel}
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
